import { useEffect, useState } from 'react'
import Default from 'components/layouts/Default/Default';
import DemoPage from 'components/templates/Demos/DemoPage';

const Demo = () => {

  return (
    <Default>
        <div className="row">

          <div className="col-12 text-white d-flex">
            <h3 className="pb-2">Demo Video</h3>
          </div>
          <div className="col-12">
            <DemoPage />
          </div>
          
        </div>

    </Default>
  )
}
// const dashboard = () => {
//     return (<div>Dashboard</div>)
// }
export default (Demo);